import { analyticsService } from './services/analyticsService';
import { TenantConfig } from './types/tenant';
import { AnalyticsConfig } from './types/analytics';

// Initialize analytics with tenant config
export const initializeTenantAnalytics = async (tenant: TenantConfig) => {
  try {
    // Extract analytics configuration from tenant
    const analyticsConfig = tenant.analytics || {};
    
    const config: AnalyticsConfig = {
      // Google Tag Manager
      gtmHead: analyticsConfig.gtmHead,
      gtmBody: analyticsConfig.gtmBody,
      // Google Analytics
      googleTag: analyticsConfig.googleTag,
      gaTrackingId: analyticsConfig.gaHead,
      // Enable debug mode in non-production
      enableDebug: window.location.hostname === 'localhost'
    };

    // Always initialize analytics service to enable web activity tracking
    await analyticsService.initialize(config);
    
    if (config.gtmHead || config.googleTag || config.gaTrackingId) {
      console.info('Analytics service initialized with Google Analytics/GTM');
    } else {
      console.info('Analytics service initialized for web activity tracking only');
    }
  } catch (error) {
    console.error('Failed to initialize analytics:', error);
    // Don't throw - allow app to continue without analytics
  }
};

// Helper function to get UTM parameters from URL
export const getUtmParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return {
    utmSource: searchParams.get('utm_source') || undefined,
    utmMedium: searchParams.get('utm_medium') || undefined,
    utmCampaign: searchParams.get('utm_campaign') || undefined,
    utmTerm: searchParams.get('utm_term') || undefined,
    utmContent: searchParams.get('utm_content') || undefined
  };
};

// Helper function to get session data
export const getSessionData = () => {
  return {
    referrer: document.referrer,
    path: window.location.pathname,
    ...getUtmParams()
  };
};
